<template>
  <lazy-vf-header-elevated v-if="$feature.tempHeaderVariation === 'elevated'" />
  <lazy-vf-header-basic v-else-if="$feature.tempHeaderVariation === 'basic'" />
  <lazy-vf-header v-else />
</template>

<script lang="ts" setup>
const LazyVfHeader = defineAsyncComponent(() => import('#brand/regions/nora/components/vf/header/Header.vue'))
</script>
